// Auto-generated by scripts/generate-version.js — do not edit
export const BUILD_HASH = "d479cfe3f1bd";
export const BUILD_VERSION_NUMBER = 43;
